import request from '@/utils/request'

// 获取门禁列表
export function listAdminAccessControl(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/iot.listAdminAccessControl',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
          total: res.total
        })
      } else {
        reject(new Error(res.msg || '获取门禁列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取管理员园区列表
export function listAdminCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listAdminCommunitys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve({
          data: res.data,
          total: res.total
        })
      } else {
        reject(new Error(res.msg || '获取园区列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}